import React from "react";
import styles from './sidebar.module.css';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBatteryFull, faHome, faWrench} from "@fortawesome/free-solid-svg-icons";
import {useNavigate, useNavigation} from "react-router-dom";

export default function Sidebar() {
    const navigate = useNavigate();

    return (
        <div className={styles.container}>
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: '2rem',
                marginBottom: '3rem',
                border: '1px solid #fff',
            }}>
                <img alt={'logo'} src={'/logo_small.png'} width={'50px'} height={'50px'}/>
            </div>

            <div className={styles.section} onClick={() => {
                navigate('/');
            }}>
                <FontAwesomeIcon icon={faHome} color={'#fff'} size={'lg'}/>
            </div>

            <div className={styles.section} onClick={() => {
                navigate('/calibration');
            }}>
                <FontAwesomeIcon icon={faWrench} color={'#fff'} size={'lg'}/>
            </div>

            <div className={styles.section} onClick={() => {
                navigate('/tag');
            }}>
                <FontAwesomeIcon icon={faBatteryFull} color={'#fff'} size={'lg'}/>
            </div>
        </div>
    )
}